import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import pythonImage from '../../images/cardpageimages/technicalcourse/python.jpg';
import IntroVideos from "../../componants/introvideos";
import PythonModule from "../../componants/allCourseModule/TechnicalCourseModule/PythonModule";

function Python() {
  return (
    <>
      <Header />
      <BannerForAll
        title="PYTHON FULL COURSE"
        text="Our Python Full Course covers the fundamentals of Python programming, including data types, control structures, functions, and libraries. Perfect for beginners and those looking to enhance their programming skills, this course also dives into topics like data handling, object-oriented programming, and real-world applications, preparing you for diverse programming projects."
        imageone={pythonImage}
        imagetwo={pythonImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="PYTHON"
      />
      <PythonModule />
      <Footer />
    </>
  );
}

export default Python;
